import './App.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Reception from "./pages/Reception";
import Login from "./pages/Login";
import DetailsReception from "./pages/DetailsReception";
import Error404 from "./pages/Error404";
import Navbarsrc from "./components/Navbar";
import { useState, useEffect } from "react"
import { AuthContext } from './helpers/AuthContext';

function App() {
  const [authState, setAuthState] = useState(AuthContext);

  useEffect(() =>{
    if(sessionStorage.getItem("accessToken")){
      setAuthState(true);
    }else{
      setAuthState(false);
    }
  }, []);

  return (
    <div className="app">
      <Navbarsrc value={authState}/>
      <AuthContext.Provider value={{authState, setAuthState}}>
        <Routes>
          { !authState && (<>
            <Route exact path="/Login" element={<Login/>}/>
            <Route exact path="/" element={<Login/>}/>
          </>)
          }
          {authState && (<>
            <Route exact path="/" element={<Reception/>}/>
            <Route exact path="/Detalles" element={<DetailsReception/>}/>
            <Route exact path="/Login" element={<Login/>}/>
          </>)}
          <Route path='/*' exact={true} element={<Error404/>} />
        </Routes>
      </AuthContext.Provider>
    </div>
  );
}

export default App;
